export default __webpack_public_path__ + "static/media/capsule-logo.fa1bece5.png";